class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.brandTopbarSelector = ".brand-topbar";
    this.searchToggleSelector = "#searchToggle";
    this.searchFormSelector = "#searchFormWrapper";

    this.desktopBreakpoint = 992;
  }

  connectedCallback() {
    this.setupStickyHeader();
    this.setupSearchToggle();
    this.initBrandSwitcherDetection();

    console.log("[SiteHeader] Initialized");
  }

  // ===== Sticky Header =====
  setupStickyHeader() {
    const topbar = this.querySelector(this.brandTopbarSelector);
    if (!topbar) return;

    const threshold = 60;

    const update = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (window.innerWidth < this.desktopBreakpoint) {
        topbar.classList.remove("is-fixed");
        return;
      }
      topbar.classList.toggle("is-fixed", scrollY > threshold);
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
  }

  // setupSearchToggle() {
  //   const toggle = this.querySelector(this.searchToggleSelector);
  //   const wrapper = this.querySelector(this.searchFormSelector);
  //   if (!toggle || !wrapper) return;

  //   toggle.addEventListener("click", () => {
  //     wrapper.classList.toggle("d-none");
  //     const input = wrapper.querySelector("input[type='search']");
  //     if (input) input.focus();
  //   });
  // }

setupSearchToggle() {
  const toggle = this.querySelector(this.searchToggleSelector);
  const wrapper = this.querySelector(this.searchFormSelector);
  if (!toggle || !wrapper) return;

  const searchIconUrl = toggle.dataset.iconSearch;
  const closeIconUrl = toggle.dataset.iconClose;

  toggle.addEventListener("click", () => {
    wrapper.classList.toggle("d-none");
    const isNowOpen = !wrapper.classList.contains("d-none");

    // מחליף את התוכן של הכפתור לאייקון המתאים
    const iconUrl = isNowOpen ? closeIconUrl : searchIconUrl;
    toggle.innerHTML = `<img src="${iconUrl}" alt="${isNowOpen ? 'Close' : 'Search'}" class="icon-img" style="width: 24px; height: 24px;">`;

    // פוקוס על השדה אם פתוח
    if (isNowOpen) {
      const input = wrapper.querySelector("input[type='search']");
      if (input) input.focus();
    }
  });
}





  initBrandSwitcherDetection() {
    const brandSwitchers = this.querySelectorAll("brand-switcher");
    if (brandSwitchers.length) {
      console.log(`[SiteHeader] Found ${brandSwitchers.length} brand switcher component(s).`);
      brandSwitchers.forEach(sw => {
        sw.addEventListener("brand:changed", (e) => {
          console.log("[SiteHeader] Brand changed:", e.detail);
          this.updateBrandColor(e.detail.color);
        });
      });
    }
  }

  updateBrandColor(color) {
    document.documentElement.style.setProperty("--brand-active-color", color || "#000");
  }
}

customElements.define("site-header", SiteHeader);
